import { yupResolver } from "@hookform/resolvers/yup";
// import CheckBoxIcon from "@mui/icons-material/CheckBox";
// import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  // FormControl,
  FormControlLabel,
  Checkbox as MUICheckbox,
  // Tabs,
  // Tab,
  Box, Paper,
  Typography,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Grid, IconButton, Collapse,
  TextField,
  FormControl,
} from "@mui/material";

import {
  useStoreActions,
  useStoreState
} from "easy-peasy";
import * as React from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { Autocomplete, FileListField, Select, DateField, FileField }
  from "../../components";
import api from "../../services/api";
import { tiposCargas, tiposServicos, deparaTecnologiasSistemasTomadaPreco, deparaServicosSistemasTomadaPreco, tituloTabelaAddOrcamentoPorCarga, tituloTabelaAddOrcamentoPorServico, tituloTabelaAddTomadaPorCarga, dialogoTomadaPreco } from "../../static";
import { formatCurrency, parseValue } from "../../services/utils";
import { renovarUrlArquivo } from "../../services/arquivos";

import {
  KeyboardArrowDown, KeyboardArrowUp
  //  , RequestQuoteOutlined 
} from "@mui/icons-material";

//import ViewTomadaPrecoFaseOneHeader from "../../components/TomadaPreco/ViewTomadaPrecoFaseOneHeader";
//import ViewTomadaPrecoFaseOneBody from "../../components/TomadaPreco/ViewTomadaPrecoFaseOneBody";

// import PropTypes from 'prop-types';
// import { ConstructionOutlined } from "@mui/icons-material";

//import { ViewTableBodyIluminacao } from "./BodyFaseOne/ViewTableBodyIluminacao";

import '../StepPreDiagnosticoRelatorios/ModalRelResumo.css';

import FaseTwoTabelaItens from "./BodyItensFaseTwo/FaseTwoTabelaItens";

import { DialogoVisualizador } from '../../components';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import RequestQuoteOutlinedIcon from '@mui/icons-material/RequestQuoteOutlined';
// import userEvent from "@testing-library/user-event";
// import { set } from "date-fns";
// const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
// const checkedIcon = <CheckBoxIcon fontSize="small" />;

const DialogoAcompanhaOrcamentosFaseTwo = ({ open, onClose, orcamento, itens, isFornecedor = false }) => {
  // let user = useStoreState((state) => state.auth.user);
  let loading = useStoreState((state) => state.nav.loading);
  let startLoading = useStoreActions((actions) => actions.nav.startLoading);
  let stopLoading = useStoreActions((actions) => actions.nav.stopLoading);
  // let currProcesso = useStoreState((state) => state.processo.current);

  const [save, setSave] = React.useState(false);
  const [send, setSend] = React.useState(false);
  const [metas, setMetas] = React.useState([]);
  const [atividades, setAtividades] = React.useState({});
  const [openRows, setOpenRows] = React.useState({});
  const [openDlgVis, setOpenDlgVis] = React.useState(false);
  const [fileVisualizador, setFileVisualizador] = React.useState();
  const [documento, setDocumento] = React.useState(orcamento?.documentoId || null);
  const [isSelected, setIsSelected] = React.useState(false);
  const [rows, setRows] = React.useState(itens?.data || []);
  const [isDisabled, setIsDisabled] = React.useState(true);
  const [totalSumFontes, setTotalSumFontes] = React.useState(0);
  const [totalSumColunas, setTotalSumColunas] = React.useState(0);
  const [prazoEntrega, setPrazoEntrega] = React.useState(orcamento?.prazoEntrega ?? "");
  const [observacoes, setObservacoes] = React.useState(orcamento?.observacoes ?? "");

  const defaultValues = {
    documentoId: orcamento?.documentoId || null,
  };

  const schema = yup
    .object({
      documentoId: yup.number()
      .positive()
      .nullable()
      .label("Orçamento"),
    });

  const useFormRef = useForm({
    mode: "onTouched",
    resolver: yupResolver(schema),
    defaultValues: defaultValues,
  });


  const {
    watch,
    handleSubmit,
    reset,
    getValues,
    setValue,
    formState: { isDirty, isSubmitting },
  } = useFormRef;

  const handleChangeFontes = () => {
    setTotalSumFontes(
      parseFloat(orcamento?.servicosConsultoria) +
      parseFloat(orcamento?.treinamentos) +
      parseFloat(orcamento?.equipamentos) +
      parseFloat(orcamento?.servicosInstalacao) +
      parseFloat(orcamento?.softwares) +
      parseFloat(orcamento?.materiaPrima)
    );
  };

  const handleChangeTotalColunas = (rows) => {
    const flattenedRows = rows.flat();
    const totalSum = flattenedRows.reduce((acc, row) => {
      const rowB15 = parseFloat(row.colunaB15 || 0);
      if (rowB15 > 0) {
        return acc + rowB15;
      } else {
        return acc +
          parseFloat(row.coluna16 || 0) +
          parseFloat(row.colunaB13 || 0) +
          parseFloat(row.colunaB14 || 0);
      }
    }, 0);
  
    setTotalSumColunas(totalSum);
  };

  const checkIfIsEmptyOrNegative = (value) => {
    if (value === "" || parseFloat(value) < 0) {
      return 0;
    }
    return parseFloat(value); 
  };

  React.useEffect(async () => {
    handleChangeTotalColunas(rows);
    checkIfRowsAreValid(rows);
    if(orcamento?.documentoId) {
      const fileRef = await renovarUrlArquivo({ id: orcamento.documentoId });
      let data = {
        fileRef,
        mimeType: orcamento.mimeType || orcamento.mime_type,
        fileName: orcamento.fileName || orcamento.file_name,
        id: orcamento.documentoId,
      }
      setDocumento(data);
    }
  }, [rows, orcamento]); 

  const getSlugForIds = (tecnologiaId, servicoId) => {
    if (tecnologiaId) {
      for (const [slug, arr] of Object.entries(deparaTecnologiasSistemasTomadaPreco)) {
        if (arr.some(item => item.A === tecnologiaId)) {
          return slug;
        }
      }
    }
    if (servicoId) {
      for (const [slug, arr] of Object.entries(deparaServicosSistemasTomadaPreco)) {
        if (arr.some(item => item.S === servicoId)) {
          return slug;
        }
      }
    }
    return null;
  };

  const resolveSlugForRow = (row) => {
    const opt = row.orcamentoProcessoTipo || row.orcamento_processo_tipo;
    if (opt) {
      const slug = getSlugForIds(opt.tecnologiaId || opt.tecnologia_id, opt.servicoId || opt.servico_id);
      if (slug) return slug;
    }
    return orcamento?.tipoCarga;
  };

  // Group rows by slug
  const groupedData = React.useMemo(() => {
    const groups = {};
    rows.forEach((row, originalIndex) => {
      const slug = resolveSlugForRow(row);
      if (!groups[slug]) {
        groups[slug] = [];
      }
      groups[slug].push({ ...row, _originalIndex: originalIndex });
    });
    return groups;
  }, [rows]);

  const checkIfRowsAreValid = (updatedRows) => {
    const hasEmptyField = updatedRows.some((row) => {
      const slug = resolveSlugForRow(row);
      
      let config = {};
      if (tituloTabelaAddOrcamentoPorCarga[slug]) {
        config = tituloTabelaAddOrcamentoPorCarga[slug];
      } else if (tituloTabelaAddOrcamentoPorServico[slug]) {
        config = tituloTabelaAddOrcamentoPorServico[slug];
      } else if (tituloTabelaAddTomadaPorCarga[slug]) {
        config = {
          ...(tituloTabelaAddOrcamentoPorServico.servico || {}),
          ...tituloTabelaAddTomadaPorCarga[slug],
        };
      } else {
        config = tituloTabelaAddOrcamentoPorServico.servico || {};
      }

      const excludedColumns = ['valor total (R$)', 'Valor total R$', 'Valor unitário R$', 'Quantidade'];
      const rowRelevantFields = Object.keys(config).filter((coluna) => {
        const valor = config[coluna];
        return (
          valor &&
          valor.trim() !== "" &&
          !excludedColumns.includes(valor.trim()) &&
          coluna !== "colunaA2" &&
          coluna !== "colunaA4" &&
          (coluna === "colunaA1" || coluna.startsWith("colunaB"))
        );
      });

      return rowRelevantFields.some((field) => {
        const val = row[field];
        return val === null || val === undefined || val.toString().trim() === "";
      });
    });

    setIsDisabled(hasEmptyField);
  };

  const handleRowChange = (index, field, newValue) => {
    setRows((prevRows) => {
      const updatedRows = [...prevRows];
      const updatedRow = { ...updatedRows[index], [field]: newValue };
      
      if (field === 'coluna15') {
        const slug = resolveSlugForRow(updatedRow);
        const quantidade = tiposServicos.some((servico) => servico.id === slug)
          ? parseFloat(updatedRow.coluna14 || 0)
          : 1;
        updatedRow.coluna16 = (quantidade * parseFloat(updatedRow.coluna15 || 0)).toString();
      }

      if (field === 'coluna15' || field === 'colunaB13' || field === 'colunaB14') {
        const col16 = parseFloat(updatedRow.coluna16 || 0);
        const colB13 = parseFloat(updatedRow.colunaB13 || 0);
        const colB14 = parseFloat(updatedRow.colunaB14 || 0);
        updatedRow.colunaB15 = (col16 + colB13 + colB14).toString();
      }
      
      updatedRows[index] = updatedRow;
      return updatedRows;
    });
  };

    const getTipoCarga = (cod) => {
        if (cod === 'esco') return 'ESCO';
        let nomecarga = tiposCargas.find((e) => e.id === cod);
        if (nomecarga === undefined || nomecarga === null){
          nomecarga = tiposServicos.find((f) => f.id === cod);
        }
        return nomecarga ? nomecarga.label : "Desconhecido";
    };

  const formatDateToPtBr = (dateString) => {
    // Verifica se a string contém informações de timezone
    dateString = dateString.substring(0, 10);
    const date = new Date(dateString.includes('T') ? dateString : `${dateString}T00:00:00`);

    // Formata a data para o formato 'dd/mm/yyyy'
    return date.toLocaleDateString('pt-BR', {
      timeZone: 'America/Sao_Paulo', // Garante o fuso horário correto
    });
  };

  const close = () => {
    // reset(defaultValues);
    onClose(true);
  };

  const preencherInfo = (name, chave) => {
    // Localiza o objeto correto com base no 'name'
    const itemSelecionado = dialogoTomadaPreco.find(item => item.name === name);

    if (!itemSelecionado || !itemSelecionado[chave]) return null; // Verifica se existe a chave

    // Retorna o conteúdo para ser renderizado
    return itemSelecionado[chave].map(info => (
      <Grid container key={info.ordem} spacing={2}>
        <Grid item xs={1} className="item-response-color">
          <Typography variant="subtitle2" gutterBottom className='margemtexto'>
            {info.ordem}
          </Typography>
        </Grid>
        <Grid item xs={11} className="item-response">
          <Typography variant="subtitle2" gutterBottom className='margemtexto'>
            {info.detalhe}
          </Typography>
        </Grid>
      </Grid>
    ));
  };

  React.useEffect(() => {
    handleChangeFontes();
    if (itens?.data) {
      setRows(itens.data);
    }
    setPrazoEntrega(orcamento?.prazoEntrega ?? "");
    setObservacoes(orcamento?.observacoes ?? "");
  }, [itens]);

  const totais = React.useMemo(() => {
    const validRows = Array.isArray(itens?.data) ? itens?.data : [];
    return validRows.reduce(
      (acc, row) => ({
        coluna14: acc.coluna14 + parseValue(row.coluna14),
        coluna15: acc.coluna15 + parseValue(row.coluna15),
        coluna16: acc.coluna16 + parseValue(row.coluna16),
        colunaB13: acc.colunaB13 + parseValue(row.colunaB13),
        colunaB14: acc.colunaB14 + parseValue(row.colunaB14),
        colunaB15: acc.colunaB15 + parseValue(row.colunaB15),
      }),
      { coluna14: 0, coluna15: 0, coluna16: 0, colunaB13: 0, colunaB14: 0, colunaB15: 0 }
    );
  }, [itens?.data]);

  React.useEffect(async () => {
    try {
      handleChangeFontes();
      const getmetas = (await api.http.get("/orcamentos/processo/meta/" + orcamento?.id)).data;
      setMetas(getmetas);
      // await this.isExistsFinanceCalc();
    } catch (error) {
      console.error("Erro ao recuperar as metas:", error);
    }
  }, [orcamento?.id]);


  const isExistsFinanceCalc = async () => {
    try {
      const calculoFinanceiro = (
        await api.http.get(`orcamentos/processo/orcamento/calculo/financeiro/${orcamento?.processoId}/${orcamento?.tipoCarga}`)
      ).data;
      return Array.isArray(calculoFinanceiro) && calculoFinanceiro.length > 0;
    } catch (error) {
      console.error("Erro ao verificar cálculo financeiro existente:", error);
      return true; // Desabilita o botão em caso de erro
    }
  };

  React.useEffect(() => {
    setIsSelected(orcamento.selecionado);
  }, [orcamento])

  const fetchAtividades = async (metaId) => {
    if (atividades[metaId]) return; // Já buscou as atividades para essa meta
    try {
      const response = await api.http.get(`/orcamentos/processo/atividade/${metaId}`);
      setAtividades((prevAtividades) => ({
        ...prevAtividades,
        [metaId]: response.data,
      }));
    } catch (error) {
      console.error("Erro ao recuperar atividades:", error);
    }
  };

  const handleRowClick = (metaId) => {
    setOpenRows((prevOpenRows) => ({
      ...prevOpenRows,
      [metaId]: !prevOpenRows[metaId],
    }));
    fetchAtividades(metaId); // Busca atividades quando a linha é expandida
  };

  async function handleSave(enviar){
    startLoading();
    try {
        const payload = {
            orcamento: {
                documentoId: watch("documentoId") || null,
                equipamentos: orcamento.equipamentos,
                softwares: orcamento.softwares,
                materiaPrima: orcamento.materiaPrima,
                treinamentos: orcamento.treinamentos,
                servicosConsultoria: orcamento.servicosConsultoria,
                servicosInstalacao: orcamento.servicosInstalacao,
                prazoEntrega,
                observacoes,
            },
            tomadas: rows.map((row) => ({
                id: row.id,
                colunaA1: row.colunaA1,
                coluna15: row.coluna15,
                coluna16: row.coluna16,
                colunaB1: row.colunaB1,
                colunaB2: row.colunaB2,
                colunaB3: row.colunaB3,
                colunaB4: row.colunaB4,
                colunaB5: row.colunaB5,
                colunaB6: row.colunaB6,
                colunaB7: row.colunaB7,
                colunaB8: row.colunaB8,
                colunaB9: row.colunaB9,
                colunaB10: row.colunaB10,
                colunaB11: row.colunaB11,
                colunaB12: row.colunaB12,
                colunaB13: row.colunaB13,
                colunaB14: row.colunaB14,
                colunaB15: row.colunaB15,
            })),
            respostaFase2At: enviar,
        };
        await api.http.put(`/fornecedores/orcamentos/processo/tomada/alterarorcamento/${orcamento?.id}`, payload);
        if(enviar){
            close();
        }
        stopLoading();
    } catch (error) {
        stopLoading({
            message: error.toString(),
            severity: "error",
        });
    }
  }

  const onOpenDlgVis = (param1, param2, param3) => {
    setFileVisualizador(param1);
    setOpenDlgVis(true);
  };
  const onCloseDlgVis = () => {
    setOpenDlgVis(false);
  };

  const containsOnlyNumbersAndSymbols = (str) => {
    const regex = /^[\d\W]+$/;
    return regex.test(str);
  }

  const onAddCalculoFinanceiro = async () => {
    try {
      startLoading();

      ////confirmar se não existe outro selecionado
      const isExstsSelecionado = await isExistsFinanceCalc();

      ////consfirmar se a data já expirou
      const isExpirado = isFutureDate(orcamento?.finishedAt);

      if (isExstsSelecionado) {
        stopLoading({
          message: "Já existe um orçamento sendo utilizado para calculo financeiro",
          severity: 'error'
        });
        return;
      }

      if (!isExpirado) {
        stopLoading({
          message: "Prazo de validade do orçamento expirado.",
          severity: 'error'
        });
        return;
      }


      await api.http.put(`/orcamentos/processo/orcamento/calculo/financeiro/${orcamento?.id}`);
      // setIsCalculoFinanceiro(true);
      stopLoading();
    } catch (error) {
      console.error("Erro ao selecionar o orçamento para calculo financeiro:", error);
      stopLoading({
        message: error.toString(),
        severity: 'error'
      });
    }
  };

  const isFutureDate = (timestamp) => {
    // Converte o timestamp para uma data
    const dateToCompare = new Date(timestamp);

    // Pega a data e hora atual
    const currentDate = new Date();

    // Retorna true se o timestamp for maior que a data atual
    return dateToCompare > currentDate;
  };

  const handleCheckboxChange = async (event) => {
    const selecionado = event.target.checked;
    setIsSelected(selecionado);

    try {
      await api.http.put(`/orcamentos/processo/selecionado/${orcamento?.id}`, {
        selecionado: selecionado,
      });
      console.log("Orçamento atualizado com sucesso:", { id: orcamento?.id, selecionado });
    } catch (error) {
      setIsSelected(!selecionado);
      console.error("Erro ao selecionar o orçamento:", error);
    }
  };

  return (
    <Dialog open={open} onClose={() => onClose()} fullScreen>
      <DialogTitle>Visualização tomada de preços 2ª Fase</DialogTitle>
      <DialogContent dividers>
        <DialogoVisualizador file={fileVisualizador} open={openDlgVis} onClose={onCloseDlgVis} />
        <Box className="title">
          <Typography align="center" variant="subtitle1" className="titleFontColor">
            PROGRAMA POTENCIALIZEE - {getTipoCarga(orcamento?.tipoCarga)}
          </Typography>
        </Box>
        {/* <Box className="title" sx={{ background: "#62bb46", width: "90%", marginTop: "40px" }}> */}
        <Grid container spacing={0} sx={{ marginTop: "10px" }}>
          <Grid item xs={6} className="item-response-color">
            <Typography align="left" variant="subtitle1" className="titleFontColor">
              PEDIDO DE ORÇAMENTO: {orcamento?.id}
            </Typography>
          </Grid>
          <Grid item xs={6} className="item-response-color">
            <Typography align="left" variant="subtitle1" className="titleFontColor">

            </Typography>
          </Grid>
        </Grid>

        {/* </Box> */}
        <Box className="title">
          <Typography align="left" variant="subtitle1" className="titleFontColor">
            DADOS DE IDENTIFICAÇÃO DO SOLICITANTE:
          </Typography>
        </Box>
        <Grid container spacing={0}>
          <Grid item xs={4} className="item-response-color">
            <Typography variant="subtitle2" gutterBottom className="titleFontColor">Nome do Especialista Responsável: </Typography>
          </Grid>
          <Grid item xs={8} className="item-response">
            <Typography variant="subtitle2" gutterBottom className='margemtexto'>{orcamento?.auditorNome}</Typography>
          </Grid>
          <Grid item xs={4} className="item-response-color">
            <Typography variant="subtitle2" gutterBottom className="titleFontColor">Email do Especialista Responsável: </Typography>
          </Grid>
          <Grid item xs={8} className="item-response">
            <Typography variant="subtitle2" gutterBottom className='margemtexto'>{orcamento?.auditorEmail}</Typography>
          </Grid>
          <Grid item xs={4} className="item-response-color">
            <Typography variant="subtitle2" gutterBottom className="titleFontColor">Cidade: </Typography>
          </Grid>
          <Grid item xs={8} className="item-response">
            <Typography variant="subtitle2" gutterBottom className='margemtexto'>{orcamento?.extras?.cidade}</Typography>
          </Grid>
          <Grid item xs={4} className="item-response-color">
            <Typography variant="subtitle2" gutterBottom className="titleFontColor">UF: </Typography>
          </Grid>
          <Grid item xs={8} className="item-response">
            <Typography variant="subtitle2" gutterBottom className='margemtexto'>{orcamento?.extras?.estado}</Typography>
          </Grid>
          <Grid item xs={4} className="item-response-color">
            <Typography variant="subtitle2" gutterBottom className="titleFontColor">Validade da proposta </Typography>
          </Grid>
          <Grid item xs={8} className="item-response">
            <Typography variant="subtitle2" gutterBottom className='margemtexto'> {orcamento?.validadeProposta} </Typography>
          </Grid>
        </Grid>

        <Box className='title'>
          <Typography variant="h6" gutterBottom className='titleFontColor'>
            INFORMAÇÕES SOBRE O FORNECEDOR:
          </Typography>
        </Box>

        <Grid container spacing={0}>
          <Grid item xs={4} className="item-response-color">
            <Typography variant="subtitle2" gutterBottom className="titleFontColor">Fornecedor:</Typography>
          </Grid>
          <Grid item xs={8} className="item-response">
            <Typography variant="subtitle2" gutterBottom className='margemtexto'> {orcamento?.fornecedorNome}</Typography>
          </Grid>

          <Grid item xs={4} className="item-response-color">
            <Typography variant="subtitle2" gutterBottom className="titleFontColor">Prazo Máximo para retorno:</Typography>
          </Grid>
          <Grid item xs={8} className="item-response">
            <Typography variant="subtitle2" gutterBottom className='margemtexto'> {orcamento.finishedAt ? formatDateToPtBr(orcamento.finishedAt) : ""}</Typography>
          </Grid>

          <Grid item xs={4} className="item-response-color">
            <Typography variant="subtitle2" gutterBottom className="titleFontColor">Data Retorno:</Typography>
          </Grid>
          <Grid item xs={8} className="item-response">
            <Typography variant="subtitle2" gutterBottom className='margemtexto'> {orcamento.respostafase1At ? formatDateToPtBr(orcamento.respostafase1At) : ""}</Typography>
          </Grid>
        </Grid>

        {Object.entries(groupedData).map(([slug, groupRows]) => (
          <Box key={slug} sx={{ mb: 4 }}>
            {tiposCargas.find((f) => f.id === slug) && (
              <>
                <Box className='title'>
                  <Typography variant="h6" gutterBottom className='titleFontColor'>
                    INFORMAÇÕES ADICIONAIS - {getTipoCarga(slug).toUpperCase()} QUE PREFERENCIALMENTE APRESENTEM:
                  </Typography>
                </Box>
                <Grid container spacing={0} className="gridTitleContainer" sx={{ mb: 2 }}>
                  {preencherInfo(slug, "infodefault")}
                </Grid>

                <Box className='title'>
                  <Typography variant="h6" gutterBottom className='titleFontColor'>
                    INFORMAÇÕES ADICIONAIS QUE DEVEM ESTAR CONTIDAS NA PROPOSTA:
                  </Typography>
                </Box>
                <Grid container spacing={0} className="gridTitleContainer" sx={{ mb: 2 }}>
                  {preencherInfo(slug, "infoproposta")}
                </Grid>
              </>
            )}

            <Box className='title'>
              <Typography variant="h6" gutterBottom className='titleFontColor'>
                INFORMAÇÕES SOBRE {getTipoCarga(slug).toUpperCase()} A SEREM ORÇADAS:
              </Typography>
            </Box>

            <FaseTwoTabelaItens
              slug={slug}
              rows={groupRows}
              isFornecedor={isFornecedor}
              onRowChange={(groupRowIndex, field, newValue) => {
                const originalIndex = groupRows[groupRowIndex]._originalIndex;
                handleRowChange(originalIndex, field, newValue);
              }}
            />
          </Box>
        ))}

        <Grid container spacing={1} sx={{ marginTop: "15px" }}>
          <Grid item xs={3} className="item-response-color">
            <Typography variant="subtitle2" gutterBottom className="titleFontColor">
              {tiposServicos.find((f) => f.id === orcamento.tipoCarga) ? 'PRAZO PARA PRESTAÇÃO DE SERVIÇO:' : 'PRAZO PARA ENVIO DO EQUIPAMENTO:'} 
            </Typography>
          </Grid>
          <Grid item xs={6} className="item-response">
            {isFornecedor ? (
              <TextField
                type="number"
                size="small"
                fullWidth
                value={prazoEntrega}
                inputProps={{ min: 1 }}
                onChange={(event) => setPrazoEntrega(event.target.value)}
              />
            ) : (
              <Typography variant="subtitle2" gutterBottom className='margemtexto'>{prazoEntrega} DIAS</Typography>
            )}
          </Grid>
          <Grid item xs={3} className="item-response">
            <Typography variant="subtitle2" gutterBottom className='gridItemTitleResponseright'>{formatCurrency(totalSumColunas)}</Typography>
          </Grid>
          <Grid item xs={3} className="item-response-color">
            <Typography variant="subtitle2" gutterBottom className="titleFontColor">CONDIÇÕES DE PAGAMENTO: </Typography>
          </Grid>
          <Grid item xs={9} className="item-response">
            {isFornecedor ? (
              <TextField
                size="small"
                fullWidth
                multiline
                value={observacoes}
                onChange={(event) => setObservacoes(event.target.value)}
              />
            ) : (
              <Typography variant="subtitle2" gutterBottom className='margemtexto'>{observacoes}</Typography>
            )}
          </Grid>
        </Grid>

        <Box className='title'>
          <Typography variant="h6" gutterBottom className='titleFontColor'>
            DETALHAMENTO TÉCNICO DA SOLICITAÇÃO:
          </Typography>
        </Box>

        <Grid container spacing={0} sx={{ width: 600, marginTop: "10px" }}>
          <Grid item xs={12} className="item-response-color">
            <Typography variant="subtitle2" gutterBottom className="titleFontColor">Quadro de usos e fontes</Typography>
          </Grid>
          <Grid item xs={6} className="item-response-color">
            <Typography variant="subtitle2" gutterBottom className="titleFontColor">Itens financiáveis </Typography>
          </Grid>
          <Grid item xs={6} className="item-response-color">
            <Typography variant="subtitle2" gutterBottom className="titleFontColor">Valor R$</Typography>
          </Grid>
          <Grid item xs={6} className="item-response">
            <Typography variant="subtitle2" gutterBottom className='margemtexto'>Equipamentos (nacionais e importados) </Typography>
          </Grid>
          <Grid item xs={6} className="item-response">
            {!isFornecedor ? (
              <Typography variant="subtitle2" gutterBottom className='margemtexto'>{!containsOnlyNumbersAndSymbols(orcamento?.equipamentos) ? orcamento?.equipamentos : formatCurrency(orcamento?.equipamentos)}</Typography>) : (
              <TextField
                id="equipamentos"
                name="equipamentos"
                type="number"
                variant="outlined"
                size="small"
                fullWidth
                defaultValue={orcamento?.equipamentos}
                value={orcamento?.equipamentos}
                onChange={(e) => {orcamento.equipamentos = checkIfIsEmptyOrNegative(e.target.value); handleChangeFontes(); }}
              />
            )}
          </Grid>

          <Grid item xs={6} className="item-response">
            <Typography variant="subtitle2" gutterBottom className='margemtexto'>Softwares </Typography>
          </Grid>
          <Grid item xs={6} className="item-response">
            {!isFornecedor ? (
            <Typography variant="subtitle2" gutterBottom className='margemtexto'>{!containsOnlyNumbersAndSymbols(orcamento?.softwares) ? orcamento?.softwares : formatCurrency(orcamento?.softwares)}</Typography> ) : (
              <TextField
                id="softwares"
                name="softwares"
                type="number"
                variant="outlined"
                size="small"
                fullWidth
                defaultValue={orcamento?.softwares}
                value={orcamento?.softwares}
                onChange={(e) => {orcamento.softwares = checkIfIsEmptyOrNegative(e.target.value); handleChangeFontes(); }}
              />
            )}
          </Grid>

          <Grid item xs={6} className="item-response">
            <Typography variant="subtitle2" gutterBottom className='margemtexto'>Matérias-primas e material de consumo </Typography>
          </Grid>
          <Grid item xs={6} className="item-response">
            {!isFornecedor ? (
            <Typography variant="subtitle2" gutterBottom className='margemtexto'>{!containsOnlyNumbersAndSymbols(orcamento?.materiaPrima) ? orcamento?.materiaPrima : formatCurrency(orcamento?.materiaPrima)}</Typography> ) : (
              <TextField
                id="materiaPrima"
                name="materiaPrima"
                type="number"
                variant="outlined"
                size="small"
                fullWidth
                defaultValue={orcamento?.materiaPrima}
                value={orcamento?.materiaPrima}
                onChange={(e) => {orcamento.materiaPrima = checkIfIsEmptyOrNegative(e.target.value); handleChangeFontes(); }}
              />
            )}
          </Grid>

          <Grid item xs={6} className="item-response">
            <Typography variant="subtitle2" gutterBottom className='margemtexto'>Treinamentos</Typography>
          </Grid>
          <Grid item xs={6} className="item-response">
            {!isFornecedor ? (
            <Typography variant="subtitle2" gutterBottom className='margemtexto'>{!containsOnlyNumbersAndSymbols(orcamento?.treinamentos) ? orcamento?.treinamentos : formatCurrency(orcamento?.treinamentos)}</Typography> ) : (
              <TextField
                id="treinamentos"
                name="treinamentos"
                variant="outlined"
                type="number"
                size="small"
                fullWidth
                defaultValue={orcamento?.treinamentos}
                value={orcamento?.treinamentos}
                onChange={(e) => {orcamento.treinamentos = checkIfIsEmptyOrNegative(e.target.value); handleChangeFontes(); }}
              />
            )}
          </Grid>

          <Grid item xs={6} className="item-response">
            <Typography variant="subtitle2" gutterBottom className='margemtexto'>Serviços de consultoria</Typography>
          </Grid>
          <Grid item xs={6} className="item-response">
            {!isFornecedor ? (
            <Typography variant="subtitle2" gutterBottom className='margemtexto'>{!containsOnlyNumbersAndSymbols(orcamento?.servicosConsultoria) ? orcamento?.servicosConsultoria : formatCurrency(orcamento?.servicosConsultoria)}</Typography> ) : (
              <TextField
                id="servicosConsultoria"
                name="servicosConsultoria"
                variant="outlined"
                size="small"
                type="number"
                fullWidth
                defaultValue={orcamento?.servicosConsultoria}
                value={orcamento?.servicosConsultoria}
                onChange={(e) => {orcamento.servicosConsultoria = checkIfIsEmptyOrNegative(e.target.value); handleChangeFontes();}}
              />
            )}
          </Grid>

          <Grid item xs={6} className="item-response">
            <Typography variant="subtitle2" gutterBottom className='margemtexto'>Serviços (instalação, descarte, obras cívis) </Typography>
          </Grid>
          <Grid item xs={6} className="item-response">
            {!isFornecedor ? (
            <Typography variant="subtitle2" gutterBottom className='margemtexto'>{!containsOnlyNumbersAndSymbols(orcamento?.servicosInstalacao) ? orcamento?.servicosInstalacao : formatCurrency(orcamento?.servicosInstalacao)}</Typography> ) : (
              <TextField
                id="servicosInstalacao"
                name="servicosInstalacao"
                variant="outlined"
                type="number"
                size="small"
                fullWidth
                defaultValue={orcamento?.servicosInstalacao}
                value={orcamento?.servicosInstalacao}
                onChange={(e) => {orcamento.servicosInstalacao = checkIfIsEmptyOrNegative(e.target.value); handleChangeFontes(); }}
              />
            )}
          </Grid>

          <Grid item xs={6} className="item-response-color">
            <Typography variant="subtitle2" gutterBottom className="titleFontColor">Total do Valor </Typography>
          </Grid>
          <Grid item xs={6} className="item-response-color">
          <Typography variant="subtitle2" gutterBottom className="titleFontColor">{formatCurrency(totalSumFontes)}</Typography>
          </Grid>

        </Grid>

        {/* <Box className="title">
          <Typography align="left" variant="subtitle1" className="titleFontColor">
            DADOS DO PROJETO / CRONOGRAMA FÍSICO
          </Typography>
        </Box>

        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell />
                <TableCell>Meta</TableCell>
                <TableCell>Início</TableCell>
                <TableCell>Fim</TableCell>
                <TableCell>Dias Totais</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {metas.map((meta) => (
                <React.Fragment key={meta.id}>
                  <TableRow>
                    <TableCell>
                      <IconButton onClick={() => handleRowClick(meta.id)}>
                        {openRows[meta.id] ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                      </IconButton>
                    </TableCell>
                    <TableCell>{meta.medidaEe}</TableCell>
                    <TableCell>{meta.inicio}</TableCell>
                    <TableCell>{meta.fim}</TableCell>
                    <TableCell>{meta.diasTotais}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={4} style={{ paddingBottom: 0, paddingTop: 0 }}>
                      <Collapse in={openRows[meta.id]} timeout="auto" unmountOnExit>
                        <Table size="small">
                          <TableHead>
                            <TableRow>
                              <TableCell>Atividade</TableCell>
                              <TableCell>Indicador Execução</TableCell>
                              <TableCell>Início</TableCell>
                              <TableCell>Fim</TableCell>
                              <TableCell>Dias</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {(atividades[meta.id] || []).map((atividade, index) => (
                              <TableRow key={index}>
                                <TableCell>{atividade.atividade}</TableCell>
                                <TableCell>{atividade.indicadorExecucao}</TableCell>
                                <TableCell>{atividade.inicio}</TableCell>
                                <TableCell>{atividade.fim}</TableCell>
                                <TableCell>{atividade.diasTotais}</TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </Collapse>
                    </TableCell>
                  </TableRow>
                </React.Fragment>
              ))}
            </TableBody>
          </Table>
        </TableContainer> */}

      </DialogContent>
      <DialogActions>
        {loading > 0 && (
          <CircularProgress
            size={30}
            sx={{
              position: "absolute",
              left: 25,
              bottom: 12,
            }}
          />
        )}
        <React.Fragment>
          <Grid item xs={6}>
            <FormControl sx={{ my: 2 }} fullWidth>
              <FileField
                field="documentoId"
                fileData={documento}
                useFormRef={useFormRef}
                disabled={!isFornecedor}
                schema={schema}
              />
            </FormControl>
          </Grid>
        </React.Fragment>
        {isFornecedor && <Button onClick={() => handleSave()}>
          SALVAR
        </Button>}
        {isFornecedor && <Button color="secondary" disabled={isDisabled || !prazoEntrega || !observacoes || !watch("documentoId")} onClick={() => handleSave(true)}>
          ENVIAR
        </Button>}
        <Button color="inherit" onClick={() => close()}>
          FECHAR
        </Button>

      </DialogActions>
    </Dialog>
  );
};

export default DialogoAcompanhaOrcamentosFaseTwo;
